import React from 'react';

import DashboardSearchInfo from './DashboardSearchInfo';
import { Container, SearchHeader, SearchInput } from './DashboardSearchInputStyle';
import { FlowerInfoWrapper, Text, StrongText } from '../detail/DashboardDetailFlowerInfoStyle';
import DashboardSearchFooter from './DashboardSearchFooter';
import Graph from 'assets/icons/graph.svg';
import Magnifier from 'assets/icons/Magnifier.svg';
import BackLinkIcon from 'assets/icons/left_arrow.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState, useCallback } from 'react';
import { DashBoardCreators, resetFlowerSearchData } from 'redux/modules/dashboard';
import DashboardSearchNoResult from './DashboardSearchNoResult';
import useScroll from 'hooks/common/useScroll';

const DashboardSearchMonthTrend = () => {
   // const
   const FETCH_SIZE = 10;
   const infoIcon = document.querySelector('.moreinfo-icon');
   const infoIconTop = infoIcon?.getBoundingClientRect().top;
   const infoIconLeft = infoIcon?.getBoundingClientRect().left;

   // states
   const isScrollBottom = useScroll();
   const [isEndFetch, setEndFetch] = useState(false);
   const [page, setPage] = useState(0);
   const [flowerData, setFlowerData] = useState([]);
   const dashboardState = useSelector(state => state.dashboard);
   const { data: newFlowerData, listType, tot_cnt: totalCount } = dashboardState.searchList;

   // hooks
   const dispatch = useDispatch();
   const { name } = useParams();
   let navigate = useNavigate();
   const handleClick = useCallback(item => {
      const f_id = item.f_id;
      const f_type = item.f_type;
      const f_name = item.f_name;
      const pred_p = item.pred_p;
      const pred_b = item.pred_b;
      navigate(`/dashboard/${f_id}/${f_type}/${f_name}/${pred_p}/${pred_b}`);
   }, []);

   const MarketBuyability = pred_b => {
      switch (pred_b) {
         case 0:
            return '낮음';
         case 1:
            return '평균';
         case 2:
            return '높음';
         default:
            return '';
      }
   };
   const resetFlowerData = () => {
      dispatch(resetFlowerSearchData());
   };

   const callFetchSearchFlower = ({ page, name }) => {
      dispatch(DashBoardCreators.fetchSearchData({ page: page, name: name }));
   };

   const resetAllStates = () => {
      setPage(0);
      setFlowerData([]);
      resetFlowerData();
      setEndFetch(false);
   };

   useEffect(() => {
      callFetchSearchFlower({ page: 0, name: name });
      return () => {
         resetAllStates();
      };
   }, [name]);

   useEffect(() => {
      if (!newFlowerData || newFlowerData?.length <= 0) return;
      if (newFlowerData.length < FETCH_SIZE) setEndFetch(true);
      setFlowerData([...flowerData, ...newFlowerData]);
      setPage(page + 1);
   }, [newFlowerData]);

   useEffect(() => {
      if (isScrollBottom && !isEndFetch) {
         callFetchSearchFlower({ page: page, name: name });
      }
   }, [isScrollBottom]);

   useEffect(() => {
      if (listType === undefined || listType === null) return;
      const nameSearch = listType === 0; // 이름 검색 -> 바로 상세 이동, (1은 품목 검색)

      if (nameSearch) {
         if (!newFlowerData || newFlowerData?.length < 1) return;
         const { f_id, f_type, f_name, pred_p, pred_b } = newFlowerData[0];
         if (
            f_id === undefined ||
            f_type === undefined ||
            f_name === undefined ||
            pred_p === undefined ||
            pred_b === undefined
         )
            return;
         navigate(
            `/dashboard/${f_id}/${f_type}/${f_name}/${pred_p}/${pred_b}?listType=${listType}`,
         );
      }
   }, [listType]);

   return (
      <>
         <Container>
            <SearchHeader>
               <img src={BackLinkIcon} alt="Back Link button" onClick={() => navigate(-1)} />
            </SearchHeader>
            <SearchInput>
               <img src={Magnifier} alt="magnifier" />
               <input
                  onClick={() => navigate('/dashboard/search')}
                  type="search"
                  placeholder="꽃 품목 혹은 꽃 이름을 검색해 보세요."
                  value={name}
               />
            </SearchInput>
         </Container>

         {totalCount > 0 ? (
            <DashboardSearchInfo top={infoIconTop} left={infoIconLeft} />
         ) : (
            <DashboardSearchNoResult />
         )}

         {totalCount > 0 &&
            flowerData?.map((item, index) => {
               return (
                  <FlowerInfoWrapper key={index} onClick={() => handleClick(item)}>
                     <div>
                        <Text>{item.f_type}</Text>
                        <Text>
                           <img src={Graph} alt="Purchasability Graph" />
                           {`구매 가능성이 ${MarketBuyability(item.pred_b)} `}
                        </Text>
                     </div>
                     <div>
                        <StrongText>{item.f_name}</StrongText>
                        <span>
                           <Text>AI 예측가</Text>
                           <StrongText>{item.pred_p}</StrongText>
                           <Text>원</Text>
                        </span>
                     </div>
                  </FlowerInfoWrapper>
               );
            })}
         {totalCount > 0 ? <DashboardSearchFooter /> : ''}
      </>
   );
};

export default DashboardSearchMonthTrend;
